export default __webpack_public_path__ + "static/media/eng.6bfa3fc5.svg";